import React, { useEffect, useState } from "react";
import apiUrl from "../Apiurl";


function OrdiniInQuestoStato(props) {

    const stato = props.stato;

    const [listaOrdini, setListaOrdini] = useState([])
    /* const [duplicati,setDuplicati] = useState([]) */
    //const [ordRefr, setOrdRefr] = useState(arrayPerRefresh.length)

    useEffect(() => {
        //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
        console.log("fetcho")
        fetch(apiUrl + "/logistica/sparaOrdini/ricercaOrdiniStato/" + stato)
            .then(resp => resp.json())
            .then(data => setListaOrdini(data))
    }, []);

    /* useEffect(() => {
        const count = {};
        if (listaOrdini) {
            listaOrdini.forEach(element => {
                count[element] = (count[element] || 0) + 1;
                });
        }
        const newArr = Object.entries(count);
        const arrDuplicati = newArr.filter((pair)=> (pair[1] && pair[1] !== 1))
        setDuplicati(arrDuplicati)
    }, [listaOrdini]); */

    


    return (
        <div className="tc">
            <h4>Ordini in questo stato</h4>
            {/* <div className="mb3 b">TOT: {listaOrdini && listaOrdini.length}</div>
            <div className="mb3 b">DUPLICATI:</div>
            {duplicati && duplicati.map((dupl) => <p>{dupl[0]}: {dupl[1]}</p>)}
            <div className="mb3 b">TUTTI:</div> */}
            <div className="colonne">
                {listaOrdini && listaOrdini.map((ordine) => <p className="elementoColonna">{ordine.ordinePS}</p>)}
            </div>
        </div>
    )

}

export default OrdiniInQuestoStato;




